import { Observable, of } from 'rxjs';
import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { UserActions } from 'src/app/shared/store/user/user.actions';

export function loadReturnUrl(): Observable<boolean> {
  const store = inject(Store);
  const returnUrl = localStorage.getItem('returnUrl') ?? '';
  store.dispatch(UserActions.setReturnUrl({ returnUrl }));
  return of(true);
}
